import React from 'react'
import { useLocale } from '../contexts/LocaleContext'
import Reveal from './Reveal'

const iconProps = {
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true
}

const icons = {
  fastLogging: (
    <svg {...iconProps}><path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z" /></svg>
  ),
  progressGraphs: (
    <svg {...iconProps}><path d="M3 3v18h18" /><path d="m7 15 4-4 3 3 6-6" /><path d="M16 8h4v4" /></svg>
  ),
  personalRecords: (
    <svg {...iconProps}><path d="M8 21h8" /><path d="M12 17v4" /><path d="M7 4h10v5a5 5 0 0 1-10 0V4z" /><path d="M17 6h2a2 2 0 0 1 0 4h-2" /><path d="M7 6H5a2 2 0 0 0 0 4h2" /></svg>
  ),
  customExercises: (
    <svg {...iconProps}><path d="M6.5 6.5v11" /><path d="M17.5 6.5v11" /><path d="M3 9v6" /><path d="M21 9v6" /><path d="M6.5 12h11" /></svg>
  ),
  darkMode: (
    <svg {...iconProps}><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" /></svg>
  ),
  privacy: (
    <svg {...iconProps}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="m9 12 2 2 4-4" /></svg>
  )
}

const featureKeys = ['fastLogging', 'progressGraphs', 'personalRecords', 'customExercises', 'darkMode', 'privacy']

function Features() {
  const { t } = useLocale()

  return (
    <section id="features" className="section">
      <div className="container">
        <Reveal>
          <h2>{t.features.title}</h2>
          <p className="lead">{t.features.lead}</p>
        </Reveal>
        <div className="features">
          {featureKeys.map((key, i) => (
            <Reveal as="article" className="feature" key={key} delay={(i % 3) * 0.08}>
              <div className="icon">{icons[key]}</div>
              <h3>{t.features[key].title}</h3>
              <p>{t.features[key].description}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features
